import React, { useEffect, useRef, useState } from 'react';
import { Divider, Table,DatePicker, Popconfirm, Card, Tooltip, Switch, Input, Button, Tag, Row, Col, Drawer, Form, Select, Spin } from 'antd';
import { DepartmentDto, ItemCategoriesDto, ItemsDropDownDto, ItemsDto, PlantsDropDown } from '@gtpl/shared-models/masters';
import { CheckCircleOutlined, CloseCircleOutlined, RightSquareOutlined, EyeOutlined, EditOutlined, SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { ColumnProps } from 'antd/lib/table';
import {ItemsService} from '@gtpl/shared-services/masters';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { SaleOrderDropDownDto } from '@gtpl/shared-models/sale-management';
import { StockService, StoreConsumptionService } from '@gtpl/shared-services/procurement';
import { CSVLink } from 'react-csv';
import './store-consumption-report.css';
import { ConsumedData, ConsumptionReportRequest, StockDto } from '@gtpl/shared-models/procurement-management';
import moment from 'moment';
import{SaleOrderService} from '@gtpl/shared-services/sale-management';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { Excel } from 'antd-table-saveas-excel';
const { Option } = Select;



export interface StoreConsumptionReportProps { }

export const StoreConsumptionReport =(
  props: StoreConsumptionReportProps
) => {
  const itemService = new ItemsService;
  const [plantData, setPlantData] = useState<PlantsDropDown[]>([]);
  const searchInput = useRef(null);
  const [form] = Form.useForm();
  const [page, setPage] = React.useState(1);
  const [disable,setDisable]=useState<boolean>(false);
  
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [triggerReport, setTriggerReport] = useState(false);
  const [storeConsumptionData, setStoreConsumptionData] = useState<any[]>([]);
  const [SODataForDropDown, setSODataForDropDown] = useState<StockDto[]>([]);
  const [itemCategoryForDropDown, setItemCategoryForDropDown] = useState<StockDto[]>([]);
  const [itemNameForDropDown, setItemNameForDropDown] = useState<StockDto[]>([]);
  const [display, setDisplay] = useState<string>('none');
  const stockService = new StockService;
  const [items, setItems] = useState<ItemsDropDownDto[]>([]);
  const storeConsumptionService = new StoreConsumptionService()
  const [saleOrderData, setSaleOrderData] = useState<SaleOrderDropDownDto[]>([]);
  const { RangePicker } = DatePicker;
  const [soItemData, setSoItemData] = useState<SaleOrderDropDownDto[]>([]);
  const service = new SaleOrderService;
  const [selectedEstimatedFromDate, setSelectedEstimatedFromDate]= useState(undefined);
  const [selectedEstimatedToDate, setSelectedEstimatedToDate]= useState(undefined);
  const [NoData, setSetNoData] = useState(false);
  const [soDrop, setSoDrop] = useState<ConsumedData[]>([]);
  const [catDrop, setCatDrop] = useState<ConsumedData[]>([]);
  const [UomData, setUomData] = useState([]);

const [subCat,setsubCat]= useState<ConsumedData[]>([]);
  const [itemDrop, setItemDrop] = useState<ConsumedData[]>([]);
  const [departmentData, setDepartmentData] = useState<any[]>([]);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 100,
});

  
  useEffect(() => {
    getSoDropForScReport();
    getUomDropDown();
    getItemDropForScReport();
    // getAvailableConsumedStockForSO();
    getItemCategoryDropForStockReport();
    getItemSubcatDropForStockReport()
    getStoreConsumptionDepartments()
    
    form.setFieldsValue({
      createdDate: [(moment(moment().format("YYYY-MM-DD")).subtract(1,'months')),moment(moment().format("YYYY-MM-DD"))] 
    })
    setSelectedEstimatedFromDate((moment(moment().format("YYYY-MM-DD")).subtract(1,'months')))
    setSelectedEstimatedToDate(moment(moment().format("YYYY-MM-DD")))
}, []);
  
  const onFocus=() =>{
    console.log('focus');
  }

  const headers = [
    { label: "Consumption Code", key: "consumptionCode" },
    { label: "Indent Date", key: "consumedDate" },
    { label: "PO NUmber", key: "saleOrder" },
    { label: "Item Name", key: "itemName" },
    { label: "Issued Quantity", key: "issuedQty" }
  ];
  
  const onSearch=(val)=> {
    console.log('search:', val);
  }
  const onBlur=() =>{
    console.log('blur');
  }
  function unique(data, key) {
    return [
      ...new Map(
        data.map(x => [key(x), x])
      ).values()
    ]
  }

  // const EstimatedETDDate=(value) =>{
  //   console.log(value,'value') 
  //   if (value){
  //   const consumedFromDate = new Date(value[0].format('YYYY-MM-DD'));
  //   const consumedToDate = new Date(value[1].format('YYYY-MM-DD'));
  //   setSelectedEstimatedFromDate(consumedFromDate)
  //   setSelectedEstimatedToDate(consumedToDate)}
  // }

  const getAvailableConsumedStockForSO = (onReset?:boolean) => {
    setDisable(true)
    setTriggerReport(true)
    const req = new ConsumptionReportRequest();
    let saleOrderId = form.getFieldValue('saleOrderId')
    let itemId = form.getFieldValue('itemId')
    let uomId =form.getFieldValue('itemUom')
    let departmentId = form.getFieldValue('departmentId')
    console.log(form.getFieldValue('itemUom'),'-----')
    req.saleOrderId = saleOrderId
    req.itemId = itemId
    req.uomId = uomId
    req.departmentId=departmentId
    // req.consumedFromDate = onReset?undefined : selectedEstimatedFromDate
    // req.consumedToDate = onReset?undefined : selectedEstimatedToDate
    let itemCategoryId=form.getFieldValue('categoryName')
    


    let itemSubCategoryId= form.getFieldValue('itemSubCategoryName')
    req.itemCategoryId=itemCategoryId
    req.itemSubCategoryId=itemSubCategoryId    
    req.unitId = Number(localStorage.getItem('unit_id'))

    if (form.getFieldValue('fromDate') !== undefined) {
      req.indentFromDate = (form.getFieldValue('fromDate')[0]).format('YYYY-MM-DD');
    }
    if (form.getFieldValue('fromDate') !== undefined) {
      req.indentToDate = (form.getFieldValue('fromDate')[1]).format('YYYY-MM-DD');
    }

    if (form.getFieldValue('createdDate') !== undefined) {
      req.createdFromDate = (form.getFieldValue('createdDate')[0]).format('YYYY-MM-DD');
    }
    if (form.getFieldValue('createdDate') !== undefined) {
      req.createdToDate = (form.getFieldValue('createdDate')[1]).format('YYYY-MM-DD');
    }

    storeConsumptionService.getAvailableConsumedStockForSO(req).then(res => {
      setDisable(false)
      if (res.status) {
        setStoreConsumptionData(res.data);
        setDisplay('block');
        AlertMessages.getSuccessMessage(res.internalMessage);
      } else {
        if (res.intlCode){
          setSetNoData(true)
          setStoreConsumptionData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        }else{
          AlertMessages.getErrorMessage(res.internalMessage);
          setSetNoData(true)
        } 
      }
    }).catch(err => {
      setDisable(false)
      setStoreConsumptionData([]);
    })
  }
  // const handleSaleOrder=(value, item)=>{
  //   const newStockData = storeConsumptionData.filter(stock =>
  //     stock.saleOrderId == value
  //   )
  //   setStoreConsumptionData(newStockData);
    
  // }
  
  // const handleSaleOrder = (value, item) => {
  //   const newStockData = storeConsumptionData.filter(stock =>
  //     stock.saleOrderId == value
  //   )
  //   setStoreConsumptionData(newStockData);
  //   setSODataForDropDown(JSON.parse(JSON.stringify(unique(newStockData, it => it.saleOrderId))));
  //   //setItemCategoryForDropDown(JSON.parse(JSON.stringify(unique(newStockData, it => it.itemCategoryId))));
  //   setItemNameForDropDown(JSON.parse(JSON.stringify(unique(newStockData, it => it.itemId))));
  // }
  // const handleItemName = (value, item) => {
  //   const newStockData = storeConsumptionData.filter(stock =>
  //     stock.itemId == value
  //   )
  //   setStoreConsumptionData(newStockData);
  //   setItemNameForDropDown(JSON.parse(JSON.stringify(unique(newStockData, it => it.itemId))));
  // }

  const getItemDropForScReport = () => {
    storeConsumptionService.getItemDropForScReport({unitId:Number(localStorage.getItem('unit_id'))}).then(res => {
      if (res.status) {
        setItemDrop(res.data);
      } else {
        if (res.intlCode) {
          setItemDrop([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setItemDrop([]);
    })
  }

    const getStoreConsumptionDepartments = () => {
    storeConsumptionService.getStoreConsumptionDepartments({unitId:Number(localStorage.getItem('unit_id'))}).then(res => {
      if (res.status) {
        setDepartmentData(res.data);
      } else {
        if (res.intlCode) {
          setDepartmentData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setDepartmentData([]);
    })
  }



  const getUomDropDown = () => {
    storeConsumptionService.getUomDropDown().then(res => {
      if (res.status) {
        setUomData(res.data);
      } else {
        if (res.intlCode) {
          setUomData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setUomData([ ]);
    })
  }

 
  

  const getItemCategoryDropForStockReport = () => {
    storeConsumptionService.getItemCategoryDropForStockReport().then(res => {
      if (res.status) {
        setCatDrop(res.data);
      } else {
        if (res.intlCode) {
          setCatDrop([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setCatDrop([]);
    })
  }

  const getItemSubcatDropForStockReport = () => {
    storeConsumptionService.getItemSubcatDropForStockReport().then(res => {
      if (res.status) {
        setsubCat(res.data);
      } else {
        if (res.intlCode) {
          setsubCat([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setsubCat([]);
    })
  }
const getSoDropForScReport = () => {
  storeConsumptionService.getSoDropForScReport({unitId:Number(localStorage.getItem('unit_id'))}).then(res => {
    if (res.status) {
      setSoDrop(res.data);
    } else {
      if (res.intlCode) {
        setSoDrop([]);
        AlertMessages.getErrorMessage(res.internalMessage);
      } else {
        AlertMessages.getErrorMessage(res.internalMessage);
      }
    }
  }).catch(err => {
    AlertMessages.getErrorMessage(err.message);
    setSoDrop([]);
  })
}


  
  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) { setTimeout(() => searchInput.current.select()); }
    },
    render: text =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : text
      )
        : null

  });

  /**
   * 
   * @param selectedKeys 
   * @param confirm 
   * @param dataIndex 
   */
  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };

  const onReset = () => {
    form.resetFields();  
    // getAvailableConsumedStockForSO(true);
    setSelectedEstimatedFromDate(undefined);
     setSelectedEstimatedToDate(undefined);
     getAvailableConsumedStockForSO()

  
   }
  //  const excelcolumns = [

  //   {
  //     title: 'Unit',
  //     dataIndex: 'unitName',
  //   },
  //   {
  //     title: 'Indent Date',
  //     dataIndex: 'consumedDate',
  //     render: (text, record) => { return moment(record.consumedDate).format('YYYY-MM-DD') },
  //     // ...getColumnSearchProps('consumedDate')
  //   },
  //   {
  //     title: 'Customer PO',
  //     dataIndex: 'saleOrder',
  //   },
  //   {
  //     title: 'Store Consumption Code',
  //     dataIndex: 'consumptionCode',
  //   },
  //   {
  //     title: 'Item Name',
  //     dataIndex: 'itemName',
  //   },
  //   {
  //     title: 'issued quantity',
  //     dataIndex: 'issuedQty',
  //     render:(text)=>{
  //       return <span>{Number(text)}</span>
  //     }
  //   },
  //   {
  //     title: 'Issued To',
  //     dataIndex: 'issuedTo',
  //   },
  // ];
  
  const excelcolumns = [
    {
      title: 'Unit',
      dataIndex: 'unitName',
     
    },
    {
      title: 'Indent Date',
      dataIndex: 'consumedDate',
      render: (text, record) => { return moment(record.consumedDate).format('YYYY-MM-DD') },
    },
    {
      title: 'Created Date',
      dataIndex: 'createdDate',
      render: (text, record) => { return moment(record.createdDate).format('YYYY-MM-DD') },
    },
    {
      title: 'Customer PO',
      dataIndex: 'saleOrder',
  
    },
    {
      title: 'Issued To',
      dataIndex: 'issuedTo',
      render: (text) => (text ? text : '-'),

   
    },
    {
      title: 'Value',
      dataIndex: 'value',
    },
    
    {
      title: 'Store Consumption Code',
      dataIndex: 'consumptionCode',

    },
    {
      title: 'Department',
      dataIndex: 'departmentName',

    },


    {
      title: 'Item Name',
      dataIndex: 'itemName',
    },
    {
      title: 'Item Sub Category',
      dataIndex: 'itemSubCategoryName',
      

    },
    {
      title: 'Item Category',
      dataIndex: 'categoryName',
    
    },
    {
      title: 'Issued quantity',
      dataIndex: 'issuedQty',
      render:(text)=>{
        return <span>{Number(text)}</span>
      }
    },
    {
      title: 'Item UOM',
      dataIndex: 'itemUom',
      render: (text) => (text ? text : '-'),
    },
    {
      title: 'Location',
      dataIndex: 'rm_rack_code',
      render: (text) => (text ? text : '-'),
    },
    
  ]


   const exportExcel=()=>{
    const excel = new Excel();

    let totalValue = 0;
  
    const processedData = storeConsumptionData.map((record) => {
      const valuee = parseFloat(record.value) || 0;  
      // Accumulate totals
      totalValue += valuee;
  
      return {
        ...record,
        value: valuee.toFixed(2),
      };
    });
  
    processedData.push({
      unitName: '',
      consumedDate: '-',
      createdDate: '-',
      saleOrder: '',
      issuedTo: 'Total',
      value: totalValue.toFixed(2), 
      consumptionCode: '',
      departmentName: '',
      itemName: '',
      itemSubCategoryName: '',
      categoryName: '',
      issuedQty: '',
      itemUom: '',
      rm_rack_code:''
    });
          excel
            .addSheet('StoreConsumptionReport')
            .addColumns(excelcolumns)
            .addDataSource(processedData)
            .saveAs('StoreConsumptionReport.xlsx');
    }

   
  const columnsSkelton: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: '70px',
      render: (_, __, index) => ((pagination.current - 1) * pagination.pageSize) + index + 1,
    },
    {
      title: 'Unit',
      dataIndex: 'unitName',
      responsive: ['lg'],
      width:150,

      sorter: (a, b) => a.unitName.localeCompare(b.unitName),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('unitName')
    },
    {
      title: 'Indent Date',
      dataIndex: 'consumedDate',
      width: 80,
      align: 'left',
      sorter: (a, b) => moment(a.consumedDate).unix() - moment(b.consumedDate).unix(),
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => { return moment(record.consumedDate).format('YYYY-MM-DD') },
    },
    {
      title: 'Created Date',
      dataIndex: 'createdDate',
      width: 80,
      align: 'left',
      sorter: (a, b) => moment(a.createdDate).unix() - moment(b.createdDate).unix(),
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => { return moment(record.createdDate).format('YYYY-MM-DD') },
    },
    {
      title: 'Customer PO',
      dataIndex: 'saleOrder',
      responsive: ['lg'],

      sorter: (a, b) => a.saleOrder.localeCompare(b.saleOrder),
      ...getColumnSearchProps('saleOrder')
    },
    {
      title: 'Issued To',
      dataIndex: 'issuedTo',
      width:100,
      responsive: ['lg'],
      sorter: (a, b) => a?.issuedTo?.localeCompare(b?.issuedTo),
      ...getColumnSearchProps('issuedTo'),
      render: (text) => (text ? text : '-'),

    },
    {
      title: 'Value',
      dataIndex: 'value',
      responsive: ['lg'],
      width:100,
      sorter: (a, b) => a.value.localeCompare(b.value),
      ...getColumnSearchProps('value'),
      render: (text) => (text ? Number(text) : '-'),

    },
    
    {
      title: 'Store Consumption Code',
      dataIndex: 'consumptionCode',
      responsive: ['lg'],
      width: 150,
      align: 'left',
      sorter: (a, b) => a.consumptionCode.localeCompare(b.consumptionCode),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('consumptionCode')
    },
    {
      title: 'Department',
      dataIndex: 'departmentName',
      responsive: ['lg'],
      width: 150,
      align: 'left',
      sorter: (a, b) => a.departmentName?.localeCompare(b.departmentName),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('departmentName'),
      render: (text) => (text ? text : '-')
    },

    // {
    //   title: 'SO Number',
    //   dataIndex: 'saleOrder',

    //   sorter: (a, b) => a.saleOrder.localeCompare(b.saleOrder),
    //   sortDirections: ['descend', 'ascend'],
    //   ...getColumnSearchProps('saleOrder')
    // },
    {
      title: 'Item Name',
      dataIndex: 'itemName',
      width:100,
      responsive: ['lg'],
      sorter: (a, b) => a.itemName.localeCompare(b.itemName),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('itemName')
    },
    {
      title: 'Item Sub Category',
      dataIndex: 'itemSubCategoryName',
      width:180,
      responsive: ['lg'],
      sorter: (a, b) => a.itemSubCategoryName.localeCompare(b.itemSubCategoryName),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('itemSubCategoryName')

    },
    {
      title: 'Item Category',
      dataIndex: 'categoryName',
      width:100,
      responsive: ['lg'],
      sorter: (a, b) => a.categoryName.localeCompare(b.categoryName),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('categoryName')
    },
    {
      title: 'Issued quantity',
      dataIndex: 'issuedQty',
      width:100,
      align:'right',
      responsive: ['lg'],
      // sorter: (a, b) => a.issuedQty.localeCompare(b.issuedQty),
      // sortDirections: ['descend', 'ascend'],
      // ...getColumnSearchProps('issuedQty'),
      render:(text)=>{
        return <span>{Number(text)}</span>
      }
    },
    {
      title: 'Item UOM',
      dataIndex: 'itemUom',
      width:100,
      responsive: ['lg'],
      
      ...getColumnSearchProps('itemUom'),
      render: (text) => (text ? text : '-'),
    },
    {
      title: 'Location',
      dataIndex: 'rm_rack_code',
      width:100,
      render: (text) => (text ? text : '-'),
    },
    // {
    //   title: 'returned quantity',
    //   dataIndex: 'returnQty',
    //   // responsive: ['lg'],
    //   sorter: (a, b) => a.returnedquantity.localeCompare(b.returnedquantity),
    //   sortDirections: ['descend', 'ascend'],
    //   ...getColumnSearchProps('returnQty')
    // },
  ];

  const onChange = (pagination, filters, sorter, extra) => {
    console.log('params', pagination, filters, sorter, extra);
  }

  const handleTableChange = (pagination) => {
    setPagination(pagination);
};

  return (
    <Card title={<span style={{ color: 'white' }}>Store Consumption Report</span>} extra={<Button onClick={() => {exportExcel();}}>Get Excel</Button>}
      style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
    >
      <Form form={form} layout={'vertical'} >
      <Row gutter={[24, 24]}>
      <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
                  <Form.Item name="fromDate"
                    label="Indent Date"
                    initialValue={undefined}                  
                    rules={[
                      {
                        required: false,
                        message: " ETD Date"
                      },
                    ]}>
                    <RangePicker 
                    // onChange={EstimatedETDDate}
                     />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 6 }} xl={{ span: 6 }}>
                  <Form.Item name="createdDate"
                    label="Created Date"
                    initialValue={undefined}                  
                    rules={[
                      {
                        required: false,
                        message: " created Date"
                      },
                    ]}>
                    <RangePicker 
                    // onChange={EstimatedETDDate}
                     />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 6 }} xl={{ span: 6 }}>
               <Form.Item name="saleOrderId"
                    label="Customer PO"
                    rules=
                           {[{ required: false, message: ' Select ' },]}>
                    <Select showSearch placeholder="Select Customer po"
                            optionFilterProp="children"
                            allowClear
                           //onSelect={handleSaleOrder}
                         //filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} 
                            >
                     <Option key={0} value={null}>Select Sale Order</Option>
                      {soDrop.map((data)=>{
                        return <Option key={data.saleOrderId} value={data.saleOrderId}> {data.poNumber}</Option>
                      })}
                </Select>
                  </Form.Item>
                    </Col>




                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }} >
                        <Form.Item label="Item Category"
                            name={'categoryName'}
                            rules={[{ required: false, message: 'Missing Item Name' }]}
                        >
                            <Select
                showSearch
                allowClear
                placeholder="Select Item Category"
                optionFilterProp="children"
              //  onFocus={onFocus}
              //  onBlur={onBlur}
              //  onSearch={onSearch} 
              //filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}

              >
                <Option key={0} value={null}>Select item Category </Option>
                {catDrop.map((data) => {
                  return <Option key={data.itemCategoryId} value={data.itemCategoryId}> {data.categoryName}</Option>
                })}
              </Select>
                        </Form.Item>
                    </Col>  


                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 5 }} xl={{ span: 5 }}>
               <Form.Item name="itemSubCategoryName"
                    label="Item Sub Category"
                    rules=
                           {[{ required: false, message: ' Select ' },]}>
                    <Select showSearch placeholder="Select Item Sub Category"
                            optionFilterProp="children"
                            allowClear
                           //onSelect={handleSaleOrder}
                         //filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} 
                            >
                     <Option key={0} value={null}>Select Sub Category</Option>
                      {subCat.map((data)=>{
                        return <Option key={data.itemSubCategoryId} value={data.itemSubCategoryId}> {data.itemSubCategoryName}</Option>
                      })}
                </Select>
                  </Form.Item>
                    </Col>




                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }} >
                        <Form.Item label="Item Name"
                            name={'itemId'}
                            rules={[{ required: false, message: 'Missing Item Name' }]}
                        >
                            <Select 
                            showSearch 
                            placeholder="Select Item Name" 
                            //onSelect={handleItemName}
                            allowClear
                             filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                              dropdownMatchSelectWidth={false}>
                                {itemDrop === undefined ? '' : itemDrop.map(dropData => {
                                    return <Option key={dropData.itemId} value={dropData.itemId}>{dropData.itemName}</Option>
                                })}
                            </Select>
                        </Form.Item>
                    </Col>  



                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 4 }} xl={{ span: 4 }} >
                        <Form.Item label="Item UOM"
                            name={'itemUom'}
                            rules={[{ required: false, message: 'Select' }]}
                        >
                            <Select 
                            showSearch 
                            placeholder="Select Item UOM" 
                            //onSelect={handleItemName}
                            allowClear
                             filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                              dropdownMatchSelectWidth={false}>
                                {UomData === undefined ? '' : UomData.map(dropData => {
                                    return <Option key={dropData.uomId} value={dropData.uomId}>{dropData.itemUom}</Option>
                                })}
                            </Select>
                        </Form.Item>
                    </Col>  
                     <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }} >
                        <Form.Item label="Department"
                            name={'departmentId'}
                            rules={[{ required: false, message: 'Missing Department' }]}
                        >
                            <Select 
                            showSearch 
                            placeholder="Select Department" 
                            //onSelect={handleItemName}
                            allowClear
                             filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                              dropdownMatchSelectWidth={false}>
                                {departmentData === undefined ? '' : departmentData.map(dropData => {
                                    return <Option key={dropData.departmentId} value={dropData.departmentId}>{dropData.departmentName}</Option>
                                })}
                            </Select>
                        </Form.Item>
                    </Col>  



          <Col style={{marginTop:28}}>
          <Button
                    type="primary"
                    // icon={<SearchOutlined />}
                    // size="small"
                    disabled={disable}
                    onClick={() => getAvailableConsumedStockForSO()}
                    style={{ marginRight: 2, width: 100 }}
                    
                  >
                    Get Details
                  </Button>
                  <Button  type="primary" htmlType="submit" onClick={onReset} style={{marginLeft:'5px'}}>
                    Reset
                  </Button>
          </Col>
        </Row>
      </Form>
        {(triggerReport) ? storeConsumptionData.length > 0 ?
      <div>
      <Table
        id="emp"
        rowKey={record => record.deptId}
        columns={columnsSkelton}
        dataSource={storeConsumptionData}
        pagination={{
          pageSize: pagination.pageSize,
          current: pagination.current,
          onChange: (page, pageSize) => handleTableChange({ current: page, pageSize }),
      }}
        scroll={{ x: 'max-content', y: 300 }}
        onChange={handleTableChange}
        bordered
        summary={(pageData) => {
          let totalValue = 0;
        
          pageData.forEach(({ value }) => {
              totalValue += parseFloat(value) || 0;
            });
        
          return (
            <Table.Summary.Row>
              <Table.Summary.Cell index={5} colSpan={6}>
                Total
              </Table.Summary.Cell>
              <Table.Summary.Cell index={6}>
                {totalValue.toFixed(2)}
              </Table.Summary.Cell>
            </Table.Summary.Row>
          );
        }} 
         />
          {/* <ReactHTMLTableToExcel  
                  className="btn btn-info"  
                  table="emp"  
                  filename="ReportExcel"  
                  sheet="Sheet"  
                  buttonText="Export excel" />   */}
  </div>:NoData?<></>:<span style={{ paddingTop: '10px', textAlign: 'center' }} ><Spin /></span>:<></>}
    </Card>
  );
      
}
  
export default StoreConsumptionReport;
